(function () {
    const init = (box) => {
        document.getElementById('mainIllustrationZoom').dispatchEvent(
            new CustomEvent('loadimage', {
                detail: {
                    src: box.getAttribute('data-src'),
                    lowSrc: box.getAttribute('data-low-src'),
                    width: parseInt(box.getAttribute('data-width')),
                    height: parseInt(box.getAttribute('data-height')),
                }
            })
        );

        const setSize = () => {
            const box = document.getElementById("artworkMainIllustration");
            const imgWidth = parseInt(box.getAttribute('data-width'));
            const imgHeight = parseInt(box.getAttribute('data-height'));

            const boxHeight = window.innerHeight - 100;
            const boxWidth = box.parentNode.offsetWidth;

            const boxRatio = boxWidth / boxHeight;
            const imgRatio = imgWidth / imgHeight;

            if (boxRatio < imgRatio) {
                const w = Math.min(boxWidth, imgWidth);
                box.style.paddingBottom = ((w / boxWidth) / imgRatio * 100) + '%';
            } else {
                const h = Math.min((window.innerHeight - 100), imgHeight);
                box.style.paddingBottom = ((h / boxWidth) * 100) + '%';
            }
            box.style.visibility = 'visible';
        };

        window.addEventListener('load', setSize);

        let timeout = 0;
        window.addEventListener('resize', () => {
            clearTimeout(timeout);
            timeout = setTimeout(setSize, 100);
        });
    };

    window.addEventListener('load', () => {
        const box = document.getElementById('artworkMainIllustration');
        if (!!box) {
            init(box);
        }
    });
})();
